const BASE = "https://growthifye.com";

const upsert = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

let _overrides = null;
let _ovPromise = null;
const loadOverrides = () => {
  if (_overrides) return Promise.resolve(_overrides);
  if (!_ovPromise) {
    _ovPromise = fetch(`${process.env.REACT_APP_BACKEND_URL}/api/public/seo/overrides`)
      .then((r) => (r.ok ? r.json() : {}))
      .catch(() => ({}))
      .then((d) => { _overrides = d || {}; return _overrides; });
  }
  return _ovPromise;
};
loadOverrides();

const applyMeta = (title, description, image, path) => {
  const url = BASE + path;
  document.title = title;
  upsert("name", "description", description);
  upsert("property", "og:title", title);
  upsert("property", "og:description", description);
  upsert("property", "og:url", url);
  if (image) {
    upsert("property", "og:image", image);
    upsert("name", "twitter:image", image);
    upsert("name", "twitter:card", "summary_large_image");
  }
  upsert("name", "twitter:title", title);
  upsert("name", "twitter:description", description);
  let link = document.head.querySelector('link[rel="canonical"]');
  if (!link) {
    link = document.createElement("link");
    link.rel = "canonical";
    document.head.appendChild(link);
  }
  link.href = url;
};

// SEO Studio overrides (per path, applied by the AI "Activate all") win over hard-coded page copy
export const setSeo = (title, description, image) => {
  const path = window.location.pathname.replace(/\/+$/, "") || "/";
  applyMeta(title, description, image, path);
  loadOverrides().then((ov) => {
    if ((window.location.pathname.replace(/\/+$/, "") || "/") !== path) return;
    const o = ov[path];
    if (!o) return;
    applyMeta(o.title || title, o.description || description, image, path);
    if (o.og_title) upsert("property", "og:title", o.og_title);
    if (o.keywords && o.keywords.length) upsert("name", "keywords", o.keywords.join(", "));
    if (o.jsonld) setJsonLd("seo-override", o.jsonld);
    if (o.faq && o.faq.length) setJsonLd("seo-faq", { "@context": "https://schema.org", "@type": "FAQPage", mainEntity: o.faq.map((f) => ({ "@type": "Question", name: f.q, acceptedAnswer: { "@type": "Answer", text: f.a } })) });
  });
};

export const setRobots = (content) => upsert("name", "robots", content);

export const setHreflang = (alts) => {
  document.head.querySelectorAll('link[rel="alternate"][hreflang]').forEach((l) => l.remove());
  (alts || []).forEach(({ lang, href }) => {
    const l = document.createElement("link");
    l.rel = "alternate"; l.hreflang = lang; l.href = href;
    document.head.appendChild(l);
  });
};

export const setJsonLd = (id, data) => {
  let el = document.getElementById(`jsonld-${id}`);
  if (!el) {
    el = document.createElement("script");
    el.type = "application/ld+json";
    el.id = `jsonld-${id}`;
    document.head.appendChild(el);
  }
  el.textContent = JSON.stringify(data);
};
